import { authActions, authSelectors } from '@virtus/common/auth/reducer';
import { applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { queryMiddleware, NetworkInterface as ReduxQueryNetworkInterface } from 'redux-query';
import createSagaMiddleware from 'redux-saga';
import config from 'src/config';
import rootReducer, { RootState } from 'src/reducers/rootReducer';
import { runAllSagas } from 'src/sagas/rootSaga';
import NetworkInterface from '@virtus/common/auth/NetworkInterface';

export const getQueries = (state: RootState) => state.queries;
export const getEntities = (state: RootState) => state.entities;

let store: Store;

/** setup saga and return store ready for <Provider /> */
export const initStore = () => {
  // let networkConfig = {};
  // if(config.useAD){
  //   networkConfig = {...config.aad}
  //   networkConfig.useAD = true;
  // }
  // else{
  //   networkConfig = {...config.idp};
  //   networkConfig.useIDP = false;
  // }
  const getUsername = () => authSelectors.getUsername(store.getState());
  const sagaMiddleware = createSagaMiddleware();
  const logoutAction = authActions.aadLogout;
  const portalNetworkInterface: NetworkInterface = new NetworkInterface({
    ...config,
    nexus: config.adminConfig,
    onUnauthorized: () => store.dispatch(logoutAction()),
    getUsername,
  });
  const reduxQueryMiddleware = queryMiddleware(
    portalNetworkInterface.reduxQueryNetworkInterface.bind(portalNetworkInterface) as ReduxQueryNetworkInterface,
    getQueries,
    getEntities,
  );

  const middleware = [reduxQueryMiddleware, sagaMiddleware];
  store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));
  runAllSagas(sagaMiddleware);
  return store;
};
